import revive_payload_client_4sVQNw7RlN from "/home/gpotter/projects/gitOfs/vue/ofsprojects/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/gpotter/projects/gitOfs/vue/ofsprojects/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/gpotter/projects/gitOfs/vue/ofsprojects/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/gpotter/projects/gitOfs/vue/ofsprojects/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/gpotter/projects/gitOfs/vue/ofsprojects/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import chunk_reload_client_UciE0i6zes from "/home/gpotter/projects/gitOfs/vue/ofsprojects/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/gpotter/projects/gitOfs/vue/ofsprojects/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/gpotter/projects/gitOfs/vue/ofsprojects/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/gpotter/projects/gitOfs/vue/ofsprojects/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_LcKgStRyi6 from "/home/gpotter/projects/gitOfs/vue/ofsprojects/node_modules/nuxt-gtag/dist/runtime/plugin.client.mjs";
import sentry_client_VdOeuw25Mb from "/home/gpotter/projects/gitOfs/vue/ofsprojects/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
import sentry_client_config_o34nk2sJbg from "/home/gpotter/projects/gitOfs/vue/ofsprojects/.nuxt/sentry-client-config.mjs";
import dragscroll_client_BZczjhItaH from "/home/gpotter/projects/gitOfs/vue/ofsprojects/plugins/dragscroll.client.js";
import vue_auto_input_client_mWMWCtS8Mg from "/home/gpotter/projects/gitOfs/vue/ofsprojects/plugins/vue-auto-input.client.js";
import shepherd_client_2C8IoPKWOg from "/home/gpotter/projects/gitOfs/vue/ofsprojects/plugins/shepherd.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_LcKgStRyi6,
  sentry_client_VdOeuw25Mb,
  sentry_client_config_o34nk2sJbg,
  dragscroll_client_BZczjhItaH,
  vue_auto_input_client_mWMWCtS8Mg,
  shepherd_client_2C8IoPKWOg
]